import { type FC } from 'react'

import { useUnit } from 'effector-react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'
import {
  $uiZoomFactor,
  decreaseZoom,
  increaseZoom,
  resetZoom,
} from '@/modules/chatting/ui/header/browser-zoom/models.ts'

import MinusIcon from '../../../icons/minus.svg'
import { IconButton } from '../../components/icon-button'

interface Props {}

export const ZoomControls: FC<Props> = () => {
  const uiZoomFactor = useUnit($uiZoomFactor)

  return (
    <div className="flex items-center justify-center gap-4">
      <div className="mr-4 align-middle text-lg font-semibold">
        {Math.round(uiZoomFactor)}%
      </div>
      <IconButton
        icon={MinusIcon}
        onClick={decreaseZoom}
        iconClassName="h-7 w-7"
      />
      <IconButton
        icon={PlusIcon}
        onClick={increaseZoom}
        iconClassName="h-7 w-7"
      />
      <Button
        onClick={resetZoom}
        variant="outline"
      >
        Reset
      </Button>
    </div>
  )
}
